@for (pref of this.prefs; track pref; let i = $index) {
  @if (pref.provider === category) {
    <section>
      <mat-slide-toggle labelPosition="after" [(ngModel)]="prefValues[i]">
        {{ pref.label }}
      </mat-slide-toggle>
    </section>
  }
}